import { IOrganization } from '../common/organization/interfaces';
import { localStorageWrapper } from './localStorage';

const companyNamesForSmsMap = new Map<string, string>([
  ['J.B. HUNT', 'JB Hunt Corporate Compliance'],
]);

export const getCompanyNameForSms = (inputOrganization?: IOrganization) => {
  const organization =
    inputOrganization || localStorageWrapper.getOrganization();
  if (!organization) {
    return '';
  }
  return companyNamesForSmsMap.get(organization.name) || organization.name;
};
